"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ApiUtils_1 = require("@pbl/pbl-react-core/lib/utils/ApiUtils");
const React = require("react");
class MediaView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reactElement: undefined
        };
    }
    async componentDidMount() {
        const { mediaUrl } = this.props;
        await this.setElementFromUrl(mediaUrl);
    }
    async setElementFromUrl(mediaUrl) {
        const reactElement = await (0, ApiUtils_1.getHtmlContents)(mediaUrl);
        this.setState({ reactElement });
    }
    async componentWillReceiveProps(newProps) {
        if (newProps.mediaUrl !== this.props.mediaUrl) {
            await this.setElementFromUrl(newProps.mediaUrl);
        }
    }
    render() {
        return (0, jsx_runtime_1.jsx)("div", { children: this.state.reactElement });
    }
}
exports.default = MediaView;
//# sourceMappingURL=MediaView.js.map